module.exports = __webpack_public_path__ + "img/dynamicmaschines_thumbnail.91ac9603.webp";